/** @typedef {
 * 'client' | 'session' | 'sessionNote' | 'appointment' | 'user' | 'clinic' | 'report'
 * | 'program' | 'programTargets'
 * } CategoryIdentifier
 */

/**
 * @typedef {'text' | 'select' | 'date' | 'yesNo' | 'user'} dataFieldTypes
 */

/**
 * @typedef {
 *   'sessionName' | 'sessionActivityId' | 'sessionDate' | 'sessionStartTime' | 'sessionFinishTime'
 *   | 'enteredStartTime' | 'enteredFinishTime' | 'sessionDuration' | 'userName' | 'distance'
 *   | 'scheduledStartDate' | 'scheduledStartTime' | 'scheduledFinishTime'
 *   | 'placeOfService' | 'placeOfServiceAddress' | 'placeOfServiceCode' | 'placeOfServiceDescription'
 *   | 'serviceType' | 'serviceName' | 'serviceTaxonomy' | 'serviceCode' | 'serviceCodeV2'
 *   | 'serviceCodeModifiers' | 'diagnosisCode' | 'authorizationFundingSource' | 'authorizationRenderingProvider'
 *   | 'authorizationAuthorizedBCBA' | 'authorizationAuthorizedBCBACredentials' | 'authorizationMemberId'
 *   | 'name'| 'email'
 * } SessionNoteFields
 */

// eslint-disable-next-line import/prefer-default-export
export const CATEGORY_IDENTIFIERS = {
  CLIENT: 'client',
  STAFF_MEMBER: 'staffMember',
  STAFF_MEMBER_SYSTEM: 'staffMemberSystem',
  SESSION: 'session',
  SESSION_NOTE: 'sessionNote',
  APPOINTMENT: 'appointment',
  USER: 'user',
  CLINIC: 'clinic',
  REPORT: 'report',
  PROGRAM: 'program',
  PROGRAM_TARGETS: 'programTargets',
  ASSESSMENT_TYPE: 'assessmentType',
};

export const SYSTEM_DATA_FIELDS_IDENTIFIERS = {
  PROFESSIONAL_CREDENTIALS: 'professionalCredentials',
};

export const DATA_FIELD_TYPES = ['text', 'select', 'date', 'yesNo', 'user'];

export const SESSION_NOTE_FIELDS = {
  SESSION_NAME: 'sessionName',
  SESSION_ACTIVITY_ID: 'sessionActivityId',
  SESSION_DATE: 'sessionDate',
  SESSION_START_TIME: 'sessionStartTime',
  SESSION_FINISH_TIME: 'sessionFinishTime',
  ENTERED_START_TIME: 'enteredStartTime',
  ENTERED_FINISH_TIME: 'enteredFinishTime',
  SESSION_DURATION: 'sessionDuration',
  USER_NAME: 'userName',
  DISTANCE: 'distance',
  SCHEDULED_START_DATE: 'scheduledStartDate',
  SCHEDULED_START_TIME: 'scheduledStartTime',
  SCHEDULED_FINISH_TIME: 'scheduledFinishTime',
  PLACE_OF_SERVICE: 'placeOfService',
  PLACE_OF_SERVICE_ADDRESS: 'placeOfServiceAddress',
  PLACE_OF_SERVICE_CODE: 'placeOfServiceCode',
  PLACE_OF_SERVICE_DESCRIPTION: 'placeOfServiceDescription',
  SERVICE_TYPE: 'serviceType',
  SERVICE_NAME: 'serviceName',
  SERVICE_TAXONOMY: 'serviceTaxonomy',
  SERVICE_CODE: 'serviceCode',
  SERVICE_CODE_V2: 'serviceCodeV2', // replaces SERVICE_CODE, retains the same value for all integrations expect lumary
  // https://hi-rasmus.atlassian.net/browse/HR-3440
  SERVICE_CODE_MODIFIERS: 'serviceCodeModifiers',
  DIAGNOSIS_CODE: 'diagnosisCode',
  AUTHORIZATION_FUNDING_SOURCE: 'authorizationFundingSource',
  AUTHORIZATION_RENDERING_PROVIDER: 'authorizationRenderingProvider',
  AUTHORIZATION_AUTHORIZED_BCBA: 'authorizationAuthorizedBCBA',
  AUTHORIZATION_AUTHORIZED_BCBA_CREDENTIALS: 'authorizationAuthorizedBCBACredentials',
  AUTHORIZATION_MEMBER_ID: 'authorizationMemberId',
  NAME: 'name',
  EMAIL: 'email',
};
